import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { DecimalNumberPipe } from "./decimal-number.pipe";
import { FormErrorMessagePipe } from "./form-error-message.pipe";

const PIPES = [DecimalNumberPipe, FormErrorMessagePipe];

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [...PIPES],
  exports: [...PIPES],
})
export class PipesModule {}
